import React, { useState } from 'react';

import WpDataTableV2 from '../WpDataTable';
import { WpIcon } from 'Wpds/components/icon';

const DataTableDocs = () => {
  const data = [
    {
      id: 1,
      name: 'Test goal',
      status: 'complete',
      due: '12/22/2021',
      owner: 'Jonathan B.',
      workspace: 'workspace here',
    },
    {
      id: 2,
      name: 'Test goal 2',
      status: 'in_progress',
      due: '12/22/2021',
      owner: 'Marcus H.',
      workspace: 'workspace here 2',
    },
    {
      id: 3,
      name: 'Test goal 3',
      status: 'complete',
      due: '12/22/2021',
      owner: 'Annie O.',
      workspace: 'workspace here 2',
    },
    {
      id: 4,
      name: 'Test goal 4',
      status: 'behind',
      due: '12/22/2021',
      owner: 'William J.',
      workspace: 'workspace here 2',
    },
    {
      id: 5,
      name: 'Test goal 5',
      status: 'in_progress',
      due: '12/22/2021',
      owner: 'Ashley W.',
      workspace: 'workspace here 2',
    },
  ];

  const CustomComponent = ({ row }) => {
    let color = 'green';
    if (row.status === 'in_progress') color = 'blue';
    if (row.status === 'behind') color = 'red';

    return (
      <div>
        <WpIcon prefix="fas" name="circle" color={color} />
        <span style={{ paddingLeft: '.4rem' }}>{row.status.replace('_', ' ').toUpperCase()}</span>
      </div>
    );
  };

  const columns = [
    { label: 'Goal', selector: row => row.name },
    { label: 'Status', selector: row => row.status, component: CustomComponent },
    { label: 'Due', selector: row => row.due },
    { label: 'Owner', selector: row => row.owner },
    { label: 'Workspace', selector: row => row.workspace },
  ];

  const BasicTable = () => {
    return <WpDataTableV2 tableId="basicTable" columns={columns} data={data} striped />;
  };

  const SelectableTable = () => {
    const [selected, setSelected] = useState([]);

    return (
      <>
        <WpDataTableV2
          tableId="selectableTable"
          columns={columns}
          data={data}
          selectableSelector={row => row.id}
          onSelect={setSelected}
          selectedItems={selected}
        />
        <p>Selected Rows:</p>
        {selected.map(item => (
          <>
            <span key={item.key}>{item.name}</span>
            <br />
          </>
        ))}
      </>
    );
  };

  return (
    <>
      <h5>Basic Table</h5>
      <BasicTable />
      <br />
      <br />
      <h5>With Multi Select</h5>
      <SelectableTable />
    </>
  );
};

export default DataTableDocs;
